"use client";

import { useEffect, useState } from "react";
import ENDPOINTS, { TargetEndpointId } from "../../../constants/apis/endpoints";
import microCmsGetAuth from "../../../constants/apis/microCmsGetApiKey";
import { microCmsAuthType } from "../../../types/microCmsAuthType";
import { useSearchParams } from "next/navigation";
import plt_getOffset from "../../../libs/plt_getOffset";
import Pagination from "../../../components/molecules/Pagination/Pagination";
import useFetchInfoContentsList from "../../../hooks/useFetchInfoContentsList.hooks";
import SubPageHeader from "../../_layout/SubpageHeader/SubPageHeader";
import ArticleItemsWithImg from "../../../components/organisms/ArticleItemsWithImg/ArticleItemsWithImg";

const BlogList = (props: TargetEndpointId) => {
  const {targetEndpointId} = props;
  const endpoints = ENDPOINTS;
  const microCMSAuth: microCmsAuthType = microCmsGetAuth;

  const searchParams = useSearchParams();
  // パラメータなしは1ページとして扱う
  const currentPageNum = searchParams.get("page") || "1";

  // クエリパラメータのpage番号を元にoffsetを取得する
  const offset = plt_getOffset(Number(currentPageNum), endpoints["blog"].POSTS_PER_PAGE);
  const postsPerPage = endpoints[targetEndpointId].POSTS_PER_PAGE;

  const [response, setResponse] = useState<any>();
  const [totalCount, setTotalCount] = useState(0);
  // 不正値のとき
  const [isNotFound, setIsNotFound] = useState(false);

  useEffect(() => {
    const FetchData = async () => {
      // クエリ
      const q_plt_queries = {"endpointId": endpoints[targetEndpointId].ID, "limit": postsPerPage}
      // API GET
      const postList = await useFetchInfoContentsList(microCMSAuth, q_plt_queries, offset);
      setResponse(postList);
      setTotalCount(postList.responseBody.totalCount);

      // page=1, pageパラメータなし
      if(Number(currentPageNum) != 1 && currentPageNum == "" && postList.responseBody.contents.length <= 0) {
        setIsNotFound(true);
      }

      // page=1のときはパラメータなしに飛ばしたい。
      // currentPageNum とは別の値が必要

    }
    FetchData();
  }, [currentPageNum])

  if (isNotFound) {
    window.location.replace(`/${targetEndpointId}/`);
  }

  return (
    <>
      {/* debug code */}
      {/* {JSON.stringify(response?.responseBody)} */}

      {response?.responseBody ? (
        <div>
          <ArticleItemsWithImg
            id="articleItemsWithImgId"
            articleItems={response?.responseBody.contents}
            endpoint={targetEndpointId}
          />

          {(postsPerPage < totalCount) ? (
            <Pagination
              originalActive={offset}
              totalCount={totalCount}
              contentsName={endpoints[targetEndpointId].ID}
              postsPerPage={postsPerPage}
              pageNumber={currentPageNum}
            />
            ) : null}
        </div>
      ): null}
    </>
  )
}

export default BlogList;